// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__N2yPh","videoContainer":"Hero_videoContainer__BVOYP","char":"Hero_char__SICer","slider":"Hero_slider__3nYM4"};